import { Component, inject } from '@angular/core';
import { finalize, pipe, Observable, of } from 'rxjs';
import { API_ENDPOINTS } from '../../../../shared/utils/const';
import { Router } from '@angular/router';
import { ApiService } from '../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../shared/services/common.service';
import { AutofillmsmeService } from '../../../../shared/services/autofillmsme.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, Validators } from '@angular/forms';


@Component({
  selector: 'app-eoiotpverification',
  templateUrl: './eoiotpverification.component.html',
  styleUrl: './eoiotpverification.component.css'
})
export class EoiotpverificationComponent {
  private _formBuilder = inject(FormBuilder);
  data: any[];
  isDirty = false; // Set to true when user changes something
  loadingSequence: boolean = false;

  otpFormGroup = this._formBuilder.group({
    udyamRegistrationNumber: [{ value: '', disabled: true }],
    ownersMobileNumber: [{ value: '', disabled: true }],
    otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
  });

  constructor(
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private msme_serv: AutofillmsmeService,
    private ngxUiLoaderService: NgxUiLoaderService,) {
    this.data = [];

    this.otpFormGroup.valueChanges.subscribe(() => {
      this.isDirty = true;
    });
  }

  udyamNumber: string = '';
  mobileNumber: string = '';

  ngOnInit(): void {
    const storedUdyam = sessionStorage.getItem('Udyamno') || '';
    const storedMobile = sessionStorage.getItem('MobileNo') || '';

    this.otpFormGroup.patchValue({
      udyamRegistrationNumber: storedUdyam,
      ownersMobileNumber: storedMobile
    });

    this.otpFormGroup.get('udyamRegistrationNumber')?.disable();
    this.otpFormGroup.get('ownersMobileNumber')?.disable();
    this.udyamNumber = storedUdyam;
    this.mobileNumber = storedMobile;
    //send otp method
    if (this.mobileNumber) {
      this.SendOTP();
    }
  }
  isOTPSent: boolean = false;

  SendOTP(): void {
    if (!this.mobileNumber) {
      this.toastrService.error('Mobile number is missing. Cannot send OTP.');
      return;
    }

    const otpData = {
      otpType: 'mobile',
      otpValue: this.mobileNumber
      
      //UDYAM-MH-27-0019016
      //9049264273
    };

    //this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpData).subscribe({
      this.apiService.postRequest(API_ENDPOINTS.EOI.EOISendOTP, otpData).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.toastrService.success(response.message || 'OTP sent successfully.');
          this.isOTPSent = true; // ✅ Set flag
        } else {
          this.toastrService.error(response.message || 'Failed to send OTP. Try again.');
          this.isOTPSent = false;
        }
      },
      error: () => {
        this.toastrService.error('Error occurred while sending OTP.');
        this.isOTPSent = false;
      }
    });
  }
  

  //ngOnInit() {
  //  sessionStorage.clear();
  //  this.firstFormGroup
  //    .get('udyamRegistrationNumber')
  //    ?.valueChanges.subscribe((value: string | null) => {
  //      if (value && value.startsWith('UDYAM-MH-')) {
  //        const prefix = 'UDYAM-MH-';
  //        // Remove any non-numeric characters after the prefix
  //        let formattedValue = value.slice(prefix.length).replace(/[^0-9]/g, '');
  //        // Add a hyphen after the first two digits if needed
  //        if (formattedValue.length > 2) {
  //          formattedValue = `${formattedValue.slice(0, 2)}-${formattedValue.slice(2)}`;
  //        }
  //        // Update the field value with the formatted value
  //        this.firstFormGroup
  //          .get('udyamRegistrationNumber')
  //          ?.setValue(prefix + formattedValue, { emitEvent: false });
  //      } else if (value === null || value === '') {
  //        // Reset the value to the default prefix if empty or null
  //        this.firstFormGroup
  //          .get('udyamRegistrationNumber')
  //          ?.setValue('', { emitEvent: false });
  //      }
  //    });
  //}
  

  get f() {
    return this.otpFormGroup.controls;
  }

  isOtpVerified: boolean = false;
  isVerifyOtpButtonDisabled: boolean = false;
  resendOtpDisabled: boolean = false;

  verifyMobileOtp(): Observable<boolean> {
    const otp = this.otpFormGroup.controls['otp'].value?.toString();

    if (!otp || otp.length !== 6) {
      this.toastrService.error("Please enter a valid 6-digit OTP.");
      return of(false);
    }

    const otpdata = {
      OtpType: 'mobile',
      OtpValue: this.mobileNumber,
      
      Otp: otp
    };

    return new Observable<boolean>((observer) => {
      this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe({
        next: (res) => {
          if (res.message === "OTP verified successfully.") {
            this.toastrService.success(res.message);
            observer.next(true);
          } else {
            this.toastrService.error(res.message || "OTP verification failed.");
            observer.next(false);
          }
          observer.complete();
        },
        error: () => {
          this.toastrService.error("Error verifying OTP.");
          observer.next(false);
          observer.complete();
        }
      });
    });

    //return new Observable<boolean>((observer) => {
    //  this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe({
    //    next: (res) => {
    //      // First, handle the specific business logic error
    //      if (res.message === "EOI already exists for this UDYAM number. Duplicate submission is not allowed.") {
    //        this.toastrService.error(res.message);
    //        observer.next(false);
    //      }
    //      // Then, handle non-successful messages
    //      else if (res.message !== "OTP verified successfully.") {
    //        this.toastrService.error(res.message || "OTP verification failed.");
    //        observer.next(false);
    //      } else {
    //        // Finally, handle the successful verification message
    //        this.toastrService.success(res.message);
    //        observer.next(true);
    //      }
    //      observer.complete();
    //    },
    //    error: () => {
    //          this.toastrService.error("Error verifying OTP.");
    //          observer.next(false);
    //          observer.complete();
    //        }
    //  });
    //});
  }



  //This method is used with Udyam API Integration
  verifyUser(): void {
    if (this.otpFormGroup.invalid) {
      this.toastrService.error("Invalid form. Please fill out all required fields.");
      return;
    }

    const formValue = this.otpFormGroup.getRawValue();
    const udyamNo = formValue.udyamRegistrationNumber?.trim();
    const mobileNo = formValue.ownersMobileNumber?.trim();

    if (!udyamNo || !mobileNo) {
      this.toastrService.error("Udyam Registration Number and Mobile Number are required.");
      return;
    }

    this.loadingSequence = true; // ⬅️ Start loader before anything begins

    this.verifyMobileOtp().subscribe({
      next: (otpVerified: boolean) => {
        if (!otpVerified) {
          this.loadingSequence = false; // ⬅️ Stop loader if OTP failed
          return;
        }

        const formData = {
          udyamRegistrationNumber: udyamNo,
          ownersMobileNumber: mobileNo
        };

        const dtoUdyam = {
          authToken: "",
          clientId: "",
          udyamNo: udyamNo,
          mobile: mobileNo
        };

        this.apiService.postRequest(API_ENDPOINTS.MSME.EOIVALIDATEUSER, formData, true).subscribe({
          next: (res: any) => {
            if (res.status) {
              sessionStorage.setItem("udyamRegistrationNumber", udyamNo);
              sessionStorage.setItem("ownersMobileNumber", mobileNo);

              this.apiService.postRequest(API_ENDPOINTS.UDYAM.VERIFYUDYAM, dtoUdyam).pipe(
                finalize(() => this.loadingSequence = false) // ⬅️ Stop loader after last API
              ).subscribe({
                next: (response: any) => {
                  if (response.isResponse === 'Y') {
                    sessionStorage.setItem("isUdyamVerified", 'true');
                    sessionStorage.setItem("email", response.data.email?.trim() || '');
                    sessionStorage.setItem("EOIOtpVerified", 'true');

                    // --- START of modified code ---
                    // Create a data object to pass to the EOI page, mapping the
                    // Udyam verification response data to the EOI form field names.
                    const eoiData = {
                      UdyamRegistrationNumber: response.data.udyamRegistrationNumber,
                      EnterpriseName: response.data.nameOfEnterprise,
                      AuthorizedPersonName: response.data.name,
                      DateOfEstablishment: response.data.dateOfIncorporation,
                      PresentAddress: response.data.officialAddressOfEnterprise,
                      NICCode: response.data.activities[0].niC5DigitId,
                      Sector: response.data.majorActivity,

                    };

                    this.router.navigate(['/eoi'], { state: { eoiData } });
                  } else {
                    this.toastrService.error(response.msg);
                  }
                },
                error: () => {
                  this.toastrService.error("Error verifying with Udyam portal.");
                }
              });

            } else {
              this.loadingSequence = false; // ⬅️ Stop loader if validate API failed
              this.toastrService.warning(res.message || "Not allowed to submit EOI.");
            }
          },
          error: () => {
            this.loadingSequence = false;
            this.toastrService.error("Error validating MSME.");
          }
        });
      },
      error: () => {
        this.loadingSequence = false;
        this.toastrService.error("Error verifying OTP.");
      }
    });
  }
  
  goToLogin() {
    this.router.navigate(['']);
  }

  resendOTP() {
    if (!this.mobileNumber) {
      this.toastrService.error('Mobile number is missing. Cannot resend OTP.');
      return;
    }

    const otpData = {
      otpType: 'mobile',
      otpValue: this.mobileNumber
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpData).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.toastrService.success(response.message || 'OTP resent successfully.');
          this.isOTPSent = true; // ✅ Set flag
        } else {
          this.toastrService.error(response.message || 'Failed to resend OTP. Try again.');
          this.isOTPSent = false;
        }
      },
      error: () => {
        this.toastrService.error('Error occurred while resending OTP.');
        this.isOTPSent = false;
      }
    });
  }
}
